import ViewDetails from "../../utils/utilities/ViewDetails";

import { Tab } from "@mui/material";

import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import ContentCutRoundedIcon from '@mui/icons-material/ContentCutRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import WorkHistoryRoundedIcon from '@mui/icons-material/WorkHistoryRounded';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';

// Tabs
import RepairTab from "./Tabs/Repair";
import HistoryTab from "./Tabs/History";

// import SecurityTab from "./Tabs/Security";

  const tabContent = [
    {panel: "repair", content: <RepairTab />},
    {panel: "history", content: <HistoryTab />},
  ]

const ViewRepairTicket = () => {

  const tabs = [
    {label: "Repair", icon: <ReceiptLongRoundedIcon fontSize="small" />},
    {label: "History", icon: <WorkHistoryRoundedIcon fontSize="small" />},
  ];

  return (
    <ViewDetails title="Repair Ticket" identifier="repair_ticket_num" tabs={tabs} tabContent={tabContent} isProfile={false} url="repair_tickets">

    </ViewDetails>
  )
};

export default ViewRepairTicket;